import { render } from "./CaptionedImage.vue?vue&type=template&id=f47556ec&bindings={\"url\":\"props\",\"alt\":\"props\",\"showModal\":\"data\"}"
import script from "./CaptionedImage.vue?vue&type=script&lang=js"
export * from "./CaptionedImage.vue?vue&type=script&lang=js"
script.render = render

export default script